export default __webpack_public_path__ + "static/media/temperature.94a5c174.svg";